import { render, staticRenderFns } from "./chatContentHistory.vue?vue&type=template&id=2208ae96&scoped=true"
import script from "./chatContentHistory.vue?vue&type=script&lang=ts"
export * from "./chatContentHistory.vue?vue&type=script&lang=ts"
import style0 from "./chatContentHistory.vue?vue&type=style&index=0&id=2208ae96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2208ae96",
  null
  
)

export default component.exports